var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftBrucke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6582 10.8721L22.6582 13.1426L9.12305 13.1426C8.70313 13.1426 8.34668 13.2891 8.05371 13.582C7.76074 13.875 7.61426 14.2314 7.61426 14.6514C7.61426 15.0615 7.75586 15.4082 8.03906 15.6914L11.8477 19.5L8.84473 19.5L1.34473 12L8.84473 4.5L11.8477 4.5L8.03906 8.32324C7.75586 8.60644 7.61426 8.95312 7.61426 9.36328C7.61426 9.7832 7.76074 10.1396 8.05371 10.4326C8.34668 10.7256 8.70313 10.8721 9.12305 10.8721L22.6582 10.8721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBrucke);
export default __webpack_public_path__ + "static/media/arrow-left-brucke.65d996415758e1778b5ce0e047b654b6.svg";
export { ForwardRef as ReactComponent };